import React, { useState } from 'react';
import './App.css';
import HorasPorCliente from './components/HorasPorCliente';
import HorasPorCategoria from './components/HorasPorCategoria';
import HorasPorProducto from './components/HorasPorProducto';
import HorasPorContratante from './components/HorasPorContratante';
import HorasPorContrato from './components/HorasPorContrato';
import PWARegistration from './components/PWARegistration';
import InstallPWA from './components/InstallPWA';
import ConnectionStatus from './components/ConnectionStatus';
import MobileUpdate from './components/MobileUpdate';
import MobileDebug from './components/MobileDebug';
// import HorasPorContratante from './components/HorasPorContratante';

function App() {
  const [vistaActiva, setVistaActiva] = useState<'producto'>('producto');

  return (
    <PWARegistration>
      <div className="App">
        <ConnectionStatus />
        <MobileUpdate />
        <MobileDebug />
        <header className="App-header">
          <h1>Neos Contratos SDP - Panel de Control</h1>
          <div className="nav-buttons">
            <button 
              className={`nav-button ${vistaActiva === 'producto' ? 'activo' : ''}`}
              onClick={() => setVistaActiva('producto')}
            >
              🏭 Por Producto
            </button>
            {/* <button 
              className={`nav-button ${vistaActiva === 'contratante' ? 'activo' : ''}`}
              onClick={() => setVistaActiva('contratante')}
            >
              🏢 Por Contratante
            </button>
            <button 
              className={`nav-button ${vistaActiva === 'contrato' ? 'activo' : ''}`}
              onClick={() => setVistaActiva('contrato')}
            >
              📄 Por Contrato
            </button> */}
            {/* <button 
              className={`nav-button ${vistaActiva === 'categoria' ? 'activo' : ''}`}
              onClick={() => setVistaActiva('categoria')}
            >
              📊 Por Categoría
            </button>
            <button 
              className={`nav-button ${vistaActiva === 'cliente' ? 'activo' : ''}`}
              onClick={() => setVistaActiva('cliente')}
            >
              👥 Por Cliente
            </button> */}
          </div>
        </header>
        <main>
          {vistaActiva === 'producto' ? <HorasPorProducto /> : null}
        </main>
        <InstallPWA />
      </div>
    </PWARegistration>
  );
}

export default App; 